<template>
  <div class="intro-autobi-container">
    <common-header></common-header>
    <div class="header-banner"></div>
    <common-advantage :advantages="valuesList"></common-advantage>
    <common-advantage :advantages="advantageList"></common-advantage>
    <common-advantage :advantages="reportForms"></common-advantage>
    <div class="application-wrap">
      <common-application title="应用场景" :tabfilter="tabsfilter" :tabcontent="tabcontent"></common-application>
    </div>
    <common-footer></common-footer>
  </div>
</template>
<script>
import mainHeader from '@/components/mainheader'
import mainFooter from '@/components/mainfooter'
import advantage from '@/components/advantage'
import application from '@/components/application'
/* eslint-disable */
export default {
  name: 'app',
  components: {
    'common-header': mainHeader,
    'common-footer': mainFooter,
    'common-advantage': advantage,
    'common-application': application
  },
  data () {
    return {
      tabsfilter: ['概览', '经营', '活动', 'PMO', '场景分析'],
      tabcontent: ['sence-banner1', 'sence-banner2', 'sence-banner3', 'sence-banner4', 'sence-banner5'],
      currentTabIndex: 0,
      valuesList: {
        title: 'AutoBI的价值',
        mulitrow: false,
        list: [
          {
            key: '0',
            title: '支撑管理决策',
            desc: '管理层可以随时随地获取企业关键数据，了解运营情况，真正做到企业数据驱动业务决策。',
            iconname: 'icon-autobi-01'
          },
          {
            key: '1',
            title: '提升管理水平',
            desc: '基于数据的透明和流程化，形成一定的激励机制，目标达成情况一目了然结合奖惩机制，让管理更加高效。',
            iconname: 'icon-autobi-02'
          },
          {
            key: '2',
            title: '提高运营效率',
            desc: '大量人工制作报表、取数等操作由AutoBI来代替，提高数据的准确性及效率。',
            iconname: 'icon-autobi-03'
          },
          {
            key: '3',
            title: '改进优化业务',
            desc: '从业务本身出发，结合AutoBI的数据分析能力，找出影响关键指标的原因，并优化提升，完善业务体系，让数据真正服务于业务，达到优化业务的最终目标。',
            iconname: 'icon-autobi-04'
          }
        ]
      },
      advantageList: {
        title: 'AutoBI的优势',
        mulitrow: true,
        list: [
          {
            key: '0',
            title: '整合多数据类型，打破数据壁垒',
            desc: '支持多种数据源接入，完美整合所有业务数据，展开多维度分析，数据同步更新，及时掌握最新业务动态。',
            iconname: 'icon-autobi-05'
          },
          {
            key: '1',
            title: '不懂技术，也可以轻松处理数据',
            desc: '不用写SQL，不用会函数也可简单的进行指标维度注册，即可完成数据准备，人人都可以成为数据分析师。',
            iconname: 'icon-autobi-06'
          },
          {
            key: '2',
            title: '可视化组件，数据变化一目了然',
            desc: '指标卡、折线图、饼图、柱状图、气泡图、地图等多种可视化图表，数据变化一目了然。多种布局方式、多种过滤组件，实时数据秒级滚动显示，让数据仪表板更加生动，让你成为报表专家。',
            iconname: 'icon-autobi-07'
          },
          {
            key: '3',
            title: '简单拖拉拽即可完成仪表板配置',
            desc: '不需技术开发定制，简单的拖拽维度指标，即可配置监控仪表板。自动更新数据，提升工作效率，真正做到，让数据服务工作。',
            iconname: 'icon-autobi-08'
          },
          {
            key: '4',
            title: '灵活的仪表板展示、订阅及分享',
            desc: '快速搭建数据门户，定义自己的门户菜单，个性化的报表展示。一键完成仪表板的分享、邮件订阅及下载功能。',
            iconname: 'icon-autobi-09'
          },
          {
            key: '5',
            title: '多种接入方式，灵活部署',
            desc: '公有云，登陆云平台直接使用，无需安装软件，随时随地可监控及分析数据。私有云（独立部署），可将整套AutoBI系统布置在企业自己的私有云上，满足企业员工数据分析及监控的需求。',
            iconname: 'icon-autobi-10'
          },
          {
            key: '6',
            title: '多屏应用，多样化展示数据',
            desc: 'PC端轻松配置及查看。移动端同步适配，随时随地了解业务数据。大屏模板化配置，应用灵活。',
            iconname: 'icon-autobi-11'
          },
          {
            key: '7',
            title: '完善的权限管理，让数据更安全',
            desc: '多种用户角色权限管理，数据更安全。管理员拥有全部数据模型及仪表板权限。数据分析师拥有数据模型建立及仪表板配置权限。普通用户可以查看有权限的仪表板。',
            iconname: 'icon-autobi-12'
          }
        ]
      },
      reportForms: {
        title: '四步定报表',
        mulitrow: true,
        list: [
          {
            key: '0',
            title: '数据层',
            desc: '多数据源支持：云数据源、本地数据库。解决：云上数据无缝连接，全链路数据闭环，减少迁移导致的数据损耗。',
            iconname: 'icon-autobi-13'
          },
          {
            key: '1',
            title: '创建数据集',
            desc: '支持：多表关联、自定义字段、同步表结构、指标维度转换等。 解决：与数据源建立连接后，将对表的加工过程固化保存，避免重复操作。',
            iconname: 'icon-autobi-14'
          },
          {
            key: '2',
            title: '制作报表',
            desc: '支持：零SQL、拖拽式、提供丰富的可视化模板、快速设计仪表板。解决：高效制作仪表板、实现报表联动、快速查看仪表板效果。',
            iconname: 'icon-autobi-15'
          },
          {
            key: '3',
            title: '创建门户',
            desc: '支持：快速搭建数据门户，节省数据平台搭建成本；通过分享、权限控制、保障数据安全的同时快速洞察数据。',
            iconname: 'icon-autobi-16'
          }
        ]
      }
    }
  },
  created(){
    // pv上报
    // 埋点
    window.pvTrack = {
      site: 144,
      category: 1724,
    }
    window.trackPageView()
  },
  methods: {}
}
</script>

<style scoped>
.intro-autobi-container {
  background-color: #F7F9FA;
}
.header-banner {
  width: 100%;
  height: 544px;
  background-size: cover;
  background-image: url('./../assets/images/index-banner1.jpg');
  background-repeat: no-repeat;
  background-position: -2px 0;
}
.application-wrap {
  padding-top: 20px;
  background: #333B5B;
  margin-bottom: -2px;
  margin-top: 50px;
}
.intro-autobi-container .application-title .line i {
  background: rgba(202,206,213,.5);
}
</style>



// WEBPACK FOOTER //
// src/view/intro_autobi.vue